module.exports = __webpack_public_path__ + "static/media/bg-mletter-base.7692967b.png";